import * as React from "react";
const SvgPause = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 17 17", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.658 0h3.895v17H2.658zM10.447 0h3.895v17h-3.895z" }));
export default SvgPause;
